<div class="wechat-overlay">
    <div class="corner-arrow">↗</div>
    <div class="wechat-instruction">
        <div class="step">
            <div class="circle">1</div>
            <div class="text">
                <div>点击右上角的 <strong>···</strong> 按钮</div>
                <div>Click menu <strong>···</strong> on your top right</div>
            </div>
        </div>
        <div class="step">
            <div class="circle">2</div>
            <div class="text">
                <div>选择 <strong>🌐 在浏览器中打开</strong></div>
                <div>Choose <strong>🌐 Open with Browser</strong></div>
            </div>
        </div>
    </div>
</div>
  